import { createModalStore } from '@/shared/lib/modal';

import { RecordingIntroVariant } from '../lib/getRecordingIntroVariant';

type RecordingIntroState = {
  variant: RecordingIntroVariant;
};

// Opened by the recorder gate in place of the recorder; "Record video" in the intro opens the recorder.
export const useRecordingIntroStore = createModalStore<RecordingIntroState>({ variant: 'trial' });
